import { render, staticRenderFns } from "./KelebihanKami.vue?vue&type=template&id=bb2a937c&"
import script from "./KelebihanKami.vue?vue&type=script&lang=js&"
export * from "./KelebihanKami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports